import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  filename: string | null;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ConfirmDeleteAttachmentDialog({
  open,
  filename,
  loading = false,
  onCancel,
  onConfirm,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t("Usuń załącznik")}</DialogTitle>

      <DialogContent>
        <Typography>
          {t("Czy na pewno chcesz usunąć załącznik")}{" "}
          <strong>{filename}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t("Tej operacji nie można cofnąć.")}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          {t("Anuluj")}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
        >
          {t("Usuń")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
